import {
  CALLING_CUSTOMER,
  CALLING_QUEUE_CASE,
  OWNER_PACKAGES,
  RESET_CALLING_CUSTOMER,
  RESET_CALL_HANGUP,
  SHARE_LINK,
} from "./teleSalesDashboard.actions";

import Constants from "../../utils/CommonConstants";
import { instance } from "../../lib/api";

export const pullTMCase = () => {
  const url = "/mystique/v1/soc/pull/tenant";
  return (dispatch) => {
    return instance({
      url,
      method: "get",
    })
      .then((response) => {
        const data = response?.data?.data || {};
        // The reducer expects { pullCaseData, startOfTimer }, as pullCase sends
        const pullCaseData = data.pullCaseData || data;
        dispatch({
          type: CALLING_QUEUE_CASE,
          payload: { pullCaseData, startOfTimer: new Date().getTime() },
        });
        dispatch({ type: RESET_CALLING_CUSTOMER });
        dispatch({ type: RESET_CALL_HANGUP });
        if (!pullCaseData?.id) {
          dispatch({
            type: Constants.SNACKBAR_NOTIFICATION,
            snackBarType: "error",
            msg: "No opportunity available to pull",
          });
        }
        return response;
      })
      .catch((err) => {
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
      });
  };
};

export const handleCall = (caseId, number) => {
  const url = `/mystique/v1/cases/${caseId}/call?type=SOCASE&custNumber=${number}&subType=TenantMonetization`;
  return (dispatch) => {
    return instance({
      url,
      method: "get",
    })
      .then((response) => {
        dispatch({
          type: CALLING_CUSTOMER,
          payload: {
            status: response.data.data.status,
            id: response.data.data.id,
          },
        });
        return response.data.data.id;
      })
      .catch((err) => {
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
      });
  };
};

export const getTenantPackages = () => {
  const url = "/sapna/v2/package-price/tenant";
  return (dispatch) => {
    return instance({
      url,
      method: "get",
    })
      .then((response) => {
        dispatch({
          type: OWNER_PACKAGES,
          payload: {
            // results is { RENT: { <name>: pkg }, BUY: { <name>: pkg } }
            TenantMonetization: { ...response.data.data?.results },
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
      });
  };
};

export const shareLink = (data) => {
  const url = "/sapna/tenant/v1/share-link";
  return (dispatch) => {
    return instance({
      url,
      method: "post",
      data,
    })
      .then((response) => {
        dispatch({
          type: SHARE_LINK,
          payload: response.data.data,
          snackbar: response.data.data
            ? "Link shared successfully"
            : "Link sharing failed",
        });
      })
      .catch((err) => {
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
      });
  };
};

export const TENANT_LISTINGS_PAGE_SIZE = 5;

// Resolves to { listings, hasNext, totalCount } for one page (1-based)
export const getTenantOpportunityListings = (
  opportunityId,
  page = 1,
  size = TENANT_LISTINGS_PAGE_SIZE
) => {
  const url = `/sapna/tenant/v1/opportunity/${opportunityId}/listings?page=${page}&size=${size}`;
  return (dispatch) => {
    return instance({
      url,
      method: "get",
    })
      .then(({ data }) => ({
        listings: data.data?.listings || [],
        hasNext: !!data.data?.hasNext,
        totalCount: data.totalCount || 0,
      }))
      .catch((err) => {
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
        return { listings: [], hasNext: false, totalCount: 0 };
      });
  };
};

// Rate card (fulfilment fee) the agent pitches for a listing's locality.
// Resolves to the `data` payload, or null when none is found / the call fails.
export const getTenantFulfilmentFee = ({
  localityUuid,
  transactionType,
  leadId,
}) => {
  const params = new URLSearchParams({
    locality_uuid: localityUuid,
    transaction_type: transactionType,
    entity_type: "SEEKER",
    entity_id: leadId,
  });
  const url = `/sapna/assure/fulfilment-fees?${params.toString()}`;
  return (dispatch) => {
    return instance({
      url,
      method: "get",
    })
      .then(({ data }) => (data.data?.status === "FOUND" ? data.data : null))
      .catch((err) => {
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
        return null;
      });
  };
};
